import { generateBridge } from '../Utility/GenerateBridge';

export type PurchasesBridgeAsync = {
    initializePayments: () => Promise<boolean>;
    getCatalog: (items: IProduct[]) => Promise<IAPProduct[]>;
    getPurchases: () => Promise<INativePurchase[]>;
    purchase: (sku: string) => Promise<INativePurchaseResult>;
    consumePurchase: (purchase: INativePurchase) => Promise<PurchaseConsumeStatus>;
};

export type IProduct = { sku: string };
export interface INativePurchaseResult extends INativePurchase {
    success: boolean;
}
export interface INativePurchase {
    productId: string;
    orderId: string;
}

export interface IAPProduct {
    productId: string;
    price: string;
    priceCurrencyCode: string;
}

export enum PurchaseConsumeStatus {
    Error = 'Error',
    Failed = 'Failed',
    Success = 'Success',
    Test = 'Test',
}

export const Purchases = generateBridge({
    name: 'Purchases',
    sync: {},
    async: {
        consumePurchase: undefined,
        getCatalog: undefined,
        getPurchases: undefined,
        initializePayments: undefined,
        purchase: undefined,
    },
    event: {},
});
